export default __webpack_public_path__ + "static/media/FIGHT OR DIE 3.6e690c6b.png";